import { MobileCodeList } from "../../../../config/mobileCodeList";
import { Form, Input, Select, Space } from "antd";
import { t } from "i18next";
import React from "react";

const PhoneNumberInput = ({ form, field, fieldPath, isRequired, label, readOnly }) => {
    const countryCodes = MobileCodeList;

    const countryPath = [...fieldPath, "countryCode"];
    const numberPath = [...fieldPath, "phoneNumber"];

    return (
        <Space.Compact style={{ width: "100%" }}>
            <Form.Item
                name={countryPath}
                noStyle
                rules={[{
                    required: isRequired, message: t("errorMsg.required.requiredField", {
                        field: label
                    }),
                }]}
            >
                <Select
                    showSearch
                    //placeholder={t("selectCountryCode")}
                    style={{
                        width: 120,
                        minWidth: 110,
                        flexShrink: 0,
                    }}
                    popupMatchSelectWidth={false}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                        (option?.label ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    options={countryCodes.map((c) => ({
                        key: `${c.key}_${c.value}`,
                        label: `${t(c.label)} (${c.value})`,
                        value: c.value,
                    }))}
                    optionLabelProp="value"
                    disabled={readOnly}
                />
            </Form.Item>

            {/* Phone Number Input */}
            <Form.Item
                name={numberPath}
                noStyle
                rules={[
                    {
                        required: isRequired, message: t("errorMsg.required.requiredField", {
                            field: label
                        })
                    },
                    {
                        validator: (_, value) => {
                            if (value && !/^\d+$/.test(value))
                                return Promise.reject(new Error(t("errorMsg.invalidNumber")));
                            return Promise.resolve();
                        },
                    },
                ]}
            >
                <Input
                    type="tel"
                    onKeyDown={(e) => {
                        if (e.key.length === 1 && !/[0-9]/.test(e.key)) e.preventDefault();
                    }}
                    disabled={readOnly}
                />
            </Form.Item>
        </Space.Compact>
    );
};


export default PhoneNumberInput